import React, { useEffect } from 'react';
import { EConstructionRegistrationRoutes } from '../constructionRegistration.routes';
import { ConstructionRegistrationResumeBlock, ActionsFooter } from './styles';
import { IConstructionRegistrationState } from '../../../../store/ducks/contracts-and-constructions/types';
import { useDispatch, useSelector } from 'react-redux';
import { sendConstructionRegistration } from '../../../../store/ducks/contracts-and-constructions/actions';
import LoadingModal from '../../../../components/LoadingModal';
import { ApplicationState } from '../../../../store';
import ConstructionDataResume from './ConstructionDataResume';
import DeliveryConditionsResume from './DeliveryConditionsResume';
import { Title } from '@gerdau/hefesto/Title';
import ResponsibleOfConstructionResume from './ResponsibleOfConstructionResume';
import { Button } from '@gerdau/hefesto/Button';
import { getTaggingInformationScreen } from '../../../../utils/Tagging';
import { sendTagging } from '../../../../store/ducks/tagging/actions';

interface IConstructionDataProps {
  goToConstructionRegistrationRoute(
    route: EConstructionRegistrationRoutes
  ): void;
  constructionRegistration: IConstructionRegistrationState;
}

const Checkout: React.FC<IConstructionDataProps> = ({
  goToConstructionRegistrationRoute,
  constructionRegistration
}) => {
  const dispatch = useDispatch();

  const { screenName = '', itemDescription = '' } = getTaggingInformationScreen(
    'construction-registration_checkout'
  );

  const customerViewType = useSelector(
    (state: ApplicationState) => state.user.searchCustomerType
  );

  const { constructionData, deliveryConditions, responsiblesOfConstruction } =
    constructionRegistration;

  const onClickSendRegistration = () => {
    dispatch(
      sendConstructionRegistration(
        constructionRegistration,
        constructionData ? constructionData.customerId : '',
        customerViewType
      )
    );
  };

  const goToSuccessPage = () => {
    goToConstructionRegistrationRoute(EConstructionRegistrationRoutes.SUCCESS);
  };

  useEffect(() => {
    if (constructionRegistration.success) {
      goToSuccessPage();
    }
  });

  return (
    <div>
      <ConstructionRegistrationResumeBlock>
        <Title level={2}>Revise o cadastro da sua obra</Title>

        <span className="subtitle">
          Antes de concluir seu cadastro, sugerimos que revise se os campos
          foram preenchidos corretamente. Confira abaixo:
        </span>
      </ConstructionRegistrationResumeBlock>

      <ConstructionDataResume
        constructionData={constructionData}
        onEditClick={() => {
          dispatch(
            sendTagging({
              screenName,
              itemName: 'button:editar_dados_da_obra',
              itemDescription: `${itemDescription}_editarDadosDaObra`,
              event: 'click'
            })
          );
          goToConstructionRegistrationRoute(
            EConstructionRegistrationRoutes.CONSTRUCTION_DATA
          );
        }}
      />

      <DeliveryConditionsResume
        deliveryConditions={deliveryConditions}
        onEditClick={() => {
          dispatch(
            sendTagging({
              screenName,
              itemName: 'button:editar_condicoes_de_entrega',
              itemDescription: `${itemDescription}_editarCondicoesDeEntrega`,
              event: 'click'
            })
          );
          goToConstructionRegistrationRoute(
            EConstructionRegistrationRoutes.DELIVERY_CONDITIONS
          );
        }}
      />

      <ResponsibleOfConstructionResume
        responsiblesOfConstruction={responsiblesOfConstruction}
        onEditClick={() => {
          dispatch(
            sendTagging({
              screenName,
              itemName: 'button:editar_responsaveis_pela_obra',
              itemDescription: `${itemDescription}_editarResponsaveisPelaObra`,
              event: 'click'
            })
          );
          goToConstructionRegistrationRoute(
            EConstructionRegistrationRoutes.RESPONSIBLE_OF_CONSTRUCTION
          );
        }}
      />

      <ConstructionRegistrationResumeBlock>
        <ActionsFooter>
          <Button
            name="back"
            variant="secondary"
            onClick={() => {
              dispatch(
                sendTagging({
                  screenName,
                  itemName: 'button:voltar',
                  itemDescription: `${itemDescription}_voltar`,
                  event: 'click'
                })
              );
              goToConstructionRegistrationRoute(
                EConstructionRegistrationRoutes.RESPONSIBLE_OF_CONSTRUCTION
              );
            }}
          >
            Voltar
          </Button>

          <Button
            name="send-contract"
            onClick={() => {
              dispatch(
                sendTagging({
                  screenName,
                  itemName: 'button:concluir_cadastro',
                  itemDescription: `${itemDescription}_concluirCadastro`,
                  event: 'click'
                })
              );
              onClickSendRegistration();
            }}
          >
            Concluir cadastro
          </Button>

          <LoadingModal
            enabled={constructionRegistration.loading}
            title="Conclusão do cadastro"
            message="A obra está sendo cadastrada na Gerdau"
          />
        </ActionsFooter>
      </ConstructionRegistrationResumeBlock>
    </div>
  );
};

export default Checkout;
